/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Authentication
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const ActionResponseStatusEnum = {
    Ok: 'Ok',
    Error: 'Error',
    Bad: 'Bad',
    NoData: 'NoData'
} as const;

export type ActionResponseStatusEnum = typeof ActionResponseStatusEnum[keyof typeof ActionResponseStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ActionType = {
    Delete: 'Delete'
} as const;

export type ActionType = typeof ActionType[keyof typeof ActionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Amount = {
    NotSpecify: 'NotSpecify',
    UnderMillion: 'UnderMillion',
    MillionBetween: 'MillionBetween',
    Over10Million: 'Over10Million'
} as const;

export type Amount = typeof Amount[keyof typeof Amount];


/**
 * 
 * @export
 * @interface BeginLoginResult
 */
export interface BeginLoginResult {
    /**
     * 
     * @type {string}
     * @memberof BeginLoginResult
     */
    'Typeof2FA'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeginLoginResult
     */
    'MFATraceId'?: string | null;
}
/**
 * 
 * @export
 * @interface BeginLoginResultActionResponse
 */
export interface BeginLoginResultActionResponse {
    /**
     * 
     * @type {BeginLoginResult}
     * @memberof BeginLoginResultActionResponse
     */
    'Data'?: BeginLoginResult;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof BeginLoginResultActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BeginLoginResultActionResponse
     */
    'Error'?: string | null;
}


/**
 * 
 * @export
 * @interface BooleanActionResponse
 */
export interface BooleanActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanActionResponse
     */
    'Data'?: boolean;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof BooleanActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BooleanActionResponse
     */
    'Error'?: string | null;
}


/**
 * 
 * @export
 * @interface DateUpdateRequest
 */
export interface DateUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof DateUpdateRequest
     */
    'CustomerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DateUpdateRequest
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateUpdateRequest
     */
    'AccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateUpdateRequest
     */
    'Date'?: string;
}
/**
 * 
 * @export
 * @interface DemoAccountRequest
 */
export interface DemoAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'FingerPrint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'Password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'Surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'PhoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DemoAccountRequest
     */
    'CityCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'ExpireDate'?: string;
    /**
     * 
     * @type {Array<InterestedProducts>}
     * @memberof DemoAccountRequest
     */
    'InterestedProducts'?: Array<InterestedProducts> | null;
    /**
     * 
     * @type {Amount}
     * @memberof DemoAccountRequest
     */
    'Amount'?: Amount;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountRequest
     */
    'Address'?: string | null;
}


/**
 * 
 * @export
 * @interface EsubeLoginInfo
 */
export interface EsubeLoginInfo {
    /**
     * 
     * @type {number}
     * @memberof EsubeLoginInfo
     */
    'CustomerNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof EsubeLoginInfo
     */
    'Password'?: string | null;
}
/**
 * 
 * @export
 * @interface Int32ActionResponse
 */
export interface Int32ActionResponse {
    /**
     * 
     * @type {number}
     * @memberof Int32ActionResponse
     */
    'Data'?: number;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof Int32ActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Int32ActionResponse
     */
    'Error'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const InterestedProducts = {
    Stock: 'Stock',
    StockAndDerivative: 'StockAndDerivative',
    ExchangeAndDerivative: 'ExchangeAndDerivative'
} as const;

export type InterestedProducts = typeof InterestedProducts[keyof typeof InterestedProducts];


/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'Password'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginResult
 */
export interface LoginResult {
    /**
     * 
     * @type {string}
     * @memberof LoginResult
     */
    'TokenId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginResult
     */
    'AccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginResult
     */
    'Platform'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginResult
     */
    'ExpireDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResult
     */
    'Verified'?: boolean;
}
/**
 * 
 * @export
 * @interface LoginResultActionResponse
 */
export interface LoginResultActionResponse {
    /**
     * 
     * @type {LoginResult}
     * @memberof LoginResultActionResponse
     */
    'Data'?: LoginResult;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof LoginResultActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginResultActionResponse
     */
    'Error'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Platform = {
    None: 'None',
    Web: 'Web',
    Mobile: 'Mobile'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];


/**
 * 
 * @export
 * @interface SignOutRequest
 */
export interface SignOutRequest {
    /**
     * 
     * @type {string}
     * @memberof SignOutRequest
     */
    'IdentityToken'?: string | null;
}
/**
 * 
 * @export
 * @interface StringActionResponse
 */
export interface StringActionResponse {
    /**
     * 
     * @type {string}
     * @memberof StringActionResponse
     */
    'Data'?: string | null;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof StringActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StringActionResponse
     */
    'Error'?: string | null;
}


/**
 * 
 * @export
 * @interface WithCustomerNumberRequest
 */
export interface WithCustomerNumberRequest {
    /**
     * 
     * @type {number}
     * @memberof WithCustomerNumberRequest
     */
    'CustomerNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'Surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'PhoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WithCustomerNumberRequest
     */
    'ExpireDate'?: string;
}
/**
 * 
 * @export
 * @interface WithUsernamePaswordRequest
 */
export interface WithUsernamePaswordRequest {
    /**
     * 
     * @type {string}
     * @memberof WithUsernamePaswordRequest
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithUsernamePaswordRequest
     */
    'Password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithUsernamePaswordRequest
     */
    'Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithUsernamePaswordRequest
     */
    'Surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithUsernamePaswordRequest
     */
    'ExpireDate'?: string;
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmDemoSmsGet: async (pin: number, username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pin' is not null or undefined
            assertParamExists('apiDashboardConfirmDemoSmsGet', 'pin', pin)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('apiDashboardConfirmDemoSmsGet', 'username', username)
            const localVarPath = `/api/dashboard/confirm-demo-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DemoAccountRequest} [demoAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterDemoAccountPost: async (demoAccountRequest?: DemoAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/register-demo-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demoAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WithCustomerNumberRequest} [withCustomerNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterWithCustomerNumberPost: async (withCustomerNumberRequest?: WithCustomerNumberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/register-with-customer-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(withCustomerNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WithUsernamePaswordRequest} [withUsernamePaswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterWithUsernamePasswordPost: async (withUsernamePaswordRequest?: WithUsernamePaswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/register-with-username-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(withUsernamePaswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardSendDemoSmsGet: async (username?: string, name?: string, surname?: string, phone?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/send-demo-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['Username'] = username;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (surname !== undefined) {
                localVarQueryParameter['Surname'] = surname;
            }

            if (phone !== undefined) {
                localVarQueryParameter['Phone'] = phone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardUpdateExpireDatePost: async (dateUpdateRequest?: DateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/update-expire-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardUpdateStartDatePost: async (dateUpdateRequest?: DateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/update-start-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardConfirmDemoSmsGet(pin: number, username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardConfirmDemoSmsGet(pin, username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DemoAccountRequest} [demoAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardRegisterDemoAccountPost(demoAccountRequest?: DemoAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardRegisterDemoAccountPost(demoAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WithCustomerNumberRequest} [withCustomerNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest?: WithCustomerNumberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WithUsernamePaswordRequest} [withUsernamePaswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest?: WithUsernamePaswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardSendDemoSmsGet(username?: string, name?: string, surname?: string, phone?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardSendDemoSmsGet(username, name, surname, phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardUpdateExpireDatePost(dateUpdateRequest?: DateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardUpdateExpireDatePost(dateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardUpdateStartDatePost(dateUpdateRequest?: DateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardUpdateStartDatePost(dateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmDemoSmsGet(pin: number, username: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiDashboardConfirmDemoSmsGet(pin, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DemoAccountRequest} [demoAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterDemoAccountPost(demoAccountRequest?: DemoAccountRequest, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiDashboardRegisterDemoAccountPost(demoAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WithCustomerNumberRequest} [withCustomerNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest?: WithCustomerNumberRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WithUsernamePaswordRequest} [withUsernamePaswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest?: WithUsernamePaswordRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardSendDemoSmsGet(username?: string, name?: string, surname?: string, phone?: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiDashboardSendDemoSmsGet(username, name, surname, phone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardUpdateExpireDatePost(dateUpdateRequest?: DateUpdateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardUpdateExpireDatePost(dateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateUpdateRequest} [dateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardUpdateStartDatePost(dateUpdateRequest?: DateUpdateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardUpdateStartDatePost(dateUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} pin 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardConfirmDemoSmsGet(pin: number, username: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardConfirmDemoSmsGet(pin, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DemoAccountRequest} [demoAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardRegisterDemoAccountPost(demoAccountRequest?: DemoAccountRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardRegisterDemoAccountPost(demoAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WithCustomerNumberRequest} [withCustomerNumberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest?: WithCustomerNumberRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardRegisterWithCustomerNumberPost(withCustomerNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WithUsernamePaswordRequest} [withUsernamePaswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest?: WithUsernamePaswordRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardRegisterWithUsernamePasswordPost(withUsernamePaswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [username] 
     * @param {string} [name] 
     * @param {string} [surname] 
     * @param {string} [phone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardSendDemoSmsGet(username?: string, name?: string, surname?: string, phone?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardSendDemoSmsGet(username, name, surname, phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateUpdateRequest} [dateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardUpdateExpireDatePost(dateUpdateRequest?: DateUpdateRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardUpdateExpireDatePost(dateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateUpdateRequest} [dateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardUpdateStartDatePost(dateUpdateRequest?: DateUpdateRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardUpdateStartDatePost(dateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EsubeApi - axios parameter creator
 * @export
 */
export const EsubeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeBeginLoginPost: async (platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/esube/begin-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(esubeLoginInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeCompleteLoginForceSmsPost: async (pin?: string, mfaTraceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/esube/complete-login-force-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (mfaTraceId !== undefined) {
                localVarQueryParameter['mfaTraceId'] = mfaTraceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeCompleteLoginPost: async (pin?: string, mfaTraceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/esube/complete-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (mfaTraceId !== undefined) {
                localVarQueryParameter['mfaTraceId'] = mfaTraceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeLoginForceSmsPost: async (platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/esube/login-force-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(esubeLoginInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeLogoutPost: async (mfaTraceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/esube/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mfaTraceId !== undefined) {
                localVarQueryParameter['mfaTraceId'] = mfaTraceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EsubeApi - functional programming interface
 * @export
 */
export const EsubeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EsubeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEsubeBeginLoginPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BeginLoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEsubeBeginLoginPost(platform, esubeLoginInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEsubeCompleteLoginForceSmsPost(pin?: string, mfaTraceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEsubeCompleteLoginForceSmsPost(pin, mfaTraceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEsubeCompleteLoginPost(pin?: string, mfaTraceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEsubeCompleteLoginPost(pin, mfaTraceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEsubeLoginForceSmsPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BeginLoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEsubeLoginForceSmsPost(platform, esubeLoginInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEsubeLogoutPost(mfaTraceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEsubeLogoutPost(mfaTraceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EsubeApi - factory interface
 * @export
 */
export const EsubeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EsubeApiFp(configuration)
    return {
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeBeginLoginPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: any): AxiosPromise<BeginLoginResultActionResponse> {
            return localVarFp.apiEsubeBeginLoginPost(platform, esubeLoginInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeCompleteLoginForceSmsPost(pin?: string, mfaTraceId?: string, options?: any): AxiosPromise<LoginResultActionResponse> {
            return localVarFp.apiEsubeCompleteLoginForceSmsPost(pin, mfaTraceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [pin] 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeCompleteLoginPost(pin?: string, mfaTraceId?: string, options?: any): AxiosPromise<LoginResultActionResponse> {
            return localVarFp.apiEsubeCompleteLoginPost(pin, mfaTraceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {EsubeLoginInfo} [esubeLoginInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeLoginForceSmsPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: any): AxiosPromise<BeginLoginResultActionResponse> {
            return localVarFp.apiEsubeLoginForceSmsPost(platform, esubeLoginInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [mfaTraceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEsubeLogoutPost(mfaTraceId?: string, options?: any): AxiosPromise<BooleanActionResponse> {
            return localVarFp.apiEsubeLogoutPost(mfaTraceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EsubeApi - object-oriented interface
 * @export
 * @class EsubeApi
 * @extends {BaseAPI}
 */
export class EsubeApi extends BaseAPI {
    /**
     * 
     * @param {Platform} [platform] 
     * @param {EsubeLoginInfo} [esubeLoginInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EsubeApi
     */
    public apiEsubeBeginLoginPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: AxiosRequestConfig) {
        return EsubeApiFp(this.configuration).apiEsubeBeginLoginPost(platform, esubeLoginInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [pin] 
     * @param {string} [mfaTraceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EsubeApi
     */
    public apiEsubeCompleteLoginForceSmsPost(pin?: string, mfaTraceId?: string, options?: AxiosRequestConfig) {
        return EsubeApiFp(this.configuration).apiEsubeCompleteLoginForceSmsPost(pin, mfaTraceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [pin] 
     * @param {string} [mfaTraceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EsubeApi
     */
    public apiEsubeCompleteLoginPost(pin?: string, mfaTraceId?: string, options?: AxiosRequestConfig) {
        return EsubeApiFp(this.configuration).apiEsubeCompleteLoginPost(pin, mfaTraceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Platform} [platform] 
     * @param {EsubeLoginInfo} [esubeLoginInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EsubeApi
     */
    public apiEsubeLoginForceSmsPost(platform?: Platform, esubeLoginInfo?: EsubeLoginInfo, options?: AxiosRequestConfig) {
        return EsubeApiFp(this.configuration).apiEsubeLoginForceSmsPost(platform, esubeLoginInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [mfaTraceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EsubeApi
     */
    public apiEsubeLogoutPost(mfaTraceId?: string, options?: AxiosRequestConfig) {
        return EsubeApiFp(this.configuration).apiEsubeLogoutPost(mfaTraceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MainApi - axios parameter creator
 * @export
 */
export const MainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainAccountVerificationGet: async (fingerprint: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fingerprint' is not null or undefined
            assertParamExists('apiMainAccountVerificationGet', 'fingerprint', fingerprint)
            const localVarPath = `/api/main/account-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fingerprint !== undefined) {
                localVarQueryParameter['fingerprint'] = fingerprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} oldPasswordCrypt 
         * @param {string} newPasswordCrypt 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainChangePasswordGet: async (oldPasswordCrypt: string, newPasswordCrypt: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oldPasswordCrypt' is not null or undefined
            assertParamExists('apiMainChangePasswordGet', 'oldPasswordCrypt', oldPasswordCrypt)
            // verify required parameter 'newPasswordCrypt' is not null or undefined
            assertParamExists('apiMainChangePasswordGet', 'newPasswordCrypt', newPasswordCrypt)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMainChangePasswordGet', 'id', id)
            const localVarPath = `/api/main/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oldPasswordCrypt !== undefined) {
                localVarQueryParameter['oldPasswordCrypt'] = oldPasswordCrypt;
            }

            if (newPasswordCrypt !== undefined) {
                localVarQueryParameter['newPasswordCrypt'] = newPasswordCrypt;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainConfirmResetPasswordSmsGet: async (pin: number, username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pin' is not null or undefined
            assertParamExists('apiMainConfirmResetPasswordSmsGet', 'pin', pin)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('apiMainConfirmResetPasswordSmsGet', 'username', username)
            const localVarPath = `/api/main/confirm-reset-password-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pin] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainConfirmVerificationGet: async (pin?: number, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/confirm-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} initiator 
         * @param {string} recipient 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainEditAccountGet: async (initiator: string, recipient: string, actionType?: ActionType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiator' is not null or undefined
            assertParamExists('apiMainEditAccountGet', 'initiator', initiator)
            // verify required parameter 'recipient' is not null or undefined
            assertParamExists('apiMainEditAccountGet', 'recipient', recipient)
            const localVarPath = `/api/main/edit-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (initiator !== undefined) {
                localVarQueryParameter['initiator'] = initiator;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainMetaGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} callbackBaseUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordBeginGet: async (username: string, callbackBaseUrl: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('apiMainResetPasswordBeginGet', 'username', username)
            // verify required parameter 'callbackBaseUrl' is not null or undefined
            assertParamExists('apiMainResetPasswordBeginGet', 'callbackBaseUrl', callbackBaseUrl)
            const localVarPath = `/api/main/reset-password-begin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (callbackBaseUrl !== undefined) {
                localVarQueryParameter['callbackBaseUrl'] = callbackBaseUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fingerprint 
         * @param {string} passwordcrypt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordEndGet: async (fingerprint: string, passwordcrypt: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fingerprint' is not null or undefined
            assertParamExists('apiMainResetPasswordEndGet', 'fingerprint', fingerprint)
            // verify required parameter 'passwordcrypt' is not null or undefined
            assertParamExists('apiMainResetPasswordEndGet', 'passwordcrypt', passwordcrypt)
            const localVarPath = `/api/main/reset-password-end`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fingerprint !== undefined) {
                localVarQueryParameter['fingerprint'] = fingerprint;
            }

            if (passwordcrypt !== undefined) {
                localVarQueryParameter['passwordcrypt'] = passwordcrypt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newpasswordEncript 
         * @param {string} fingerPrint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordSmsGet: async (newpasswordEncript: string, fingerPrint: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newpasswordEncript' is not null or undefined
            assertParamExists('apiMainResetPasswordSmsGet', 'newpasswordEncript', newpasswordEncript)
            // verify required parameter 'fingerPrint' is not null or undefined
            assertParamExists('apiMainResetPasswordSmsGet', 'fingerPrint', fingerPrint)
            const localVarPath = `/api/main/reset-password-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (newpasswordEncript !== undefined) {
                localVarQueryParameter['newpasswordEncript'] = newpasswordEncript;
            }

            if (fingerPrint !== undefined) {
                localVarQueryParameter['fingerPrint'] = fingerPrint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSendResetPasswordSmsGet: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('apiMainSendResetPasswordSmsGet', 'username', username)
            const localVarPath = `/api/main/send-reset-password-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [phoneNumber] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSendVerificationSmsGet: async (phoneNumber?: string, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/send-verification-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignOutRequest} [signOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSignOutPost: async (signOutRequest?: SignOutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/sign-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [esubeToken] 
         * @param {Platform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSigninWithEsubeTokenGet: async (esubeToken?: string, platform?: Platform, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/signin-with-esube-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (esubeToken !== undefined) {
                localVarQueryParameter['esubeToken'] = esubeToken;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSigninWithUsernamePasswordPost: async (platform?: Platform, loginRequest?: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/signin-with-username-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MainApi - functional programming interface
 * @export
 */
export const MainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MainApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainAccountVerificationGet(fingerprint: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainAccountVerificationGet(fingerprint, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} oldPasswordCrypt 
         * @param {string} newPasswordCrypt 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainChangePasswordGet(oldPasswordCrypt: string, newPasswordCrypt: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainChangePasswordGet(oldPasswordCrypt, newPasswordCrypt, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainConfirmResetPasswordSmsGet(pin: number, username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainConfirmResetPasswordSmsGet(pin, username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pin] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainConfirmVerificationGet(pin?: number, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainConfirmVerificationGet(pin, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} initiator 
         * @param {string} recipient 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainEditAccountGet(initiator: string, recipient: string, actionType?: ActionType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainEditAccountGet(initiator, recipient, actionType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainMetaGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainMetaGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} callbackBaseUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainResetPasswordBeginGet(username: string, callbackBaseUrl: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainResetPasswordBeginGet(username, callbackBaseUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fingerprint 
         * @param {string} passwordcrypt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainResetPasswordEndGet(fingerprint: string, passwordcrypt: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainResetPasswordEndGet(fingerprint, passwordcrypt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} newpasswordEncript 
         * @param {string} fingerPrint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainResetPasswordSmsGet(newpasswordEncript: string, fingerPrint: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainResetPasswordSmsGet(newpasswordEncript, fingerPrint, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainSendResetPasswordSmsGet(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainSendResetPasswordSmsGet(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [phoneNumber] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainSendVerificationSmsGet(phoneNumber?: string, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainSendVerificationSmsGet(phoneNumber, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SignOutRequest} [signOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainSignOutPost(signOutRequest?: SignOutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainSignOutPost(signOutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [esubeToken] 
         * @param {Platform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainSigninWithEsubeTokenGet(esubeToken?: string, platform?: Platform, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainSigninWithEsubeTokenGet(esubeToken, platform, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMainSigninWithUsernamePasswordPost(platform?: Platform, loginRequest?: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResultActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMainSigninWithUsernamePasswordPost(platform, loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MainApi - factory interface
 * @export
 */
export const MainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MainApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainAccountVerificationGet(fingerprint: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainAccountVerificationGet(fingerprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} oldPasswordCrypt 
         * @param {string} newPasswordCrypt 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainChangePasswordGet(oldPasswordCrypt: string, newPasswordCrypt: string, id: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainChangePasswordGet(oldPasswordCrypt, newPasswordCrypt, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} pin 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainConfirmResetPasswordSmsGet(pin: number, username: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainConfirmResetPasswordSmsGet(pin, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pin] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainConfirmVerificationGet(pin?: number, email?: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainConfirmVerificationGet(pin, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} initiator 
         * @param {string} recipient 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainEditAccountGet(initiator: string, recipient: string, actionType?: ActionType, options?: any): AxiosPromise<Int32ActionResponse> {
            return localVarFp.apiMainEditAccountGet(initiator, recipient, actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainMetaGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiMainMetaGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} callbackBaseUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordBeginGet(username: string, callbackBaseUrl: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainResetPasswordBeginGet(username, callbackBaseUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fingerprint 
         * @param {string} passwordcrypt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordEndGet(fingerprint: string, passwordcrypt: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainResetPasswordEndGet(fingerprint, passwordcrypt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newpasswordEncript 
         * @param {string} fingerPrint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainResetPasswordSmsGet(newpasswordEncript: string, fingerPrint: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainResetPasswordSmsGet(newpasswordEncript, fingerPrint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSendResetPasswordSmsGet(username: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainSendResetPasswordSmsGet(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [phoneNumber] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSendVerificationSmsGet(phoneNumber?: string, email?: string, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainSendVerificationSmsGet(phoneNumber, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignOutRequest} [signOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSignOutPost(signOutRequest?: SignOutRequest, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiMainSignOutPost(signOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [esubeToken] 
         * @param {Platform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSigninWithEsubeTokenGet(esubeToken?: string, platform?: Platform, options?: any): AxiosPromise<LoginResultActionResponse> {
            return localVarFp.apiMainSigninWithEsubeTokenGet(esubeToken, platform, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Platform} [platform] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMainSigninWithUsernamePasswordPost(platform?: Platform, loginRequest?: LoginRequest, options?: any): AxiosPromise<LoginResultActionResponse> {
            return localVarFp.apiMainSigninWithUsernamePasswordPost(platform, loginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MainApi - object-oriented interface
 * @export
 * @class MainApi
 * @extends {BaseAPI}
 */
export class MainApi extends BaseAPI {
    /**
     * 
     * @param {string} fingerprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainAccountVerificationGet(fingerprint: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainAccountVerificationGet(fingerprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} oldPasswordCrypt 
     * @param {string} newPasswordCrypt 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainChangePasswordGet(oldPasswordCrypt: string, newPasswordCrypt: string, id: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainChangePasswordGet(oldPasswordCrypt, newPasswordCrypt, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} pin 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainConfirmResetPasswordSmsGet(pin: number, username: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainConfirmResetPasswordSmsGet(pin, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pin] 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainConfirmVerificationGet(pin?: number, email?: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainConfirmVerificationGet(pin, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} initiator 
     * @param {string} recipient 
     * @param {ActionType} [actionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainEditAccountGet(initiator: string, recipient: string, actionType?: ActionType, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainEditAccountGet(initiator, recipient, actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainMetaGet(options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainMetaGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} callbackBaseUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainResetPasswordBeginGet(username: string, callbackBaseUrl: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainResetPasswordBeginGet(username, callbackBaseUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fingerprint 
     * @param {string} passwordcrypt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainResetPasswordEndGet(fingerprint: string, passwordcrypt: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainResetPasswordEndGet(fingerprint, passwordcrypt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newpasswordEncript 
     * @param {string} fingerPrint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainResetPasswordSmsGet(newpasswordEncript: string, fingerPrint: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainResetPasswordSmsGet(newpasswordEncript, fingerPrint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainSendResetPasswordSmsGet(username: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainSendResetPasswordSmsGet(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [phoneNumber] 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainSendVerificationSmsGet(phoneNumber?: string, email?: string, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainSendVerificationSmsGet(phoneNumber, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignOutRequest} [signOutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainSignOutPost(signOutRequest?: SignOutRequest, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainSignOutPost(signOutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [esubeToken] 
     * @param {Platform} [platform] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainSigninWithEsubeTokenGet(esubeToken?: string, platform?: Platform, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainSigninWithEsubeTokenGet(esubeToken, platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Platform} [platform] 
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public apiMainSigninWithUsernamePasswordPost(platform?: Platform, loginRequest?: LoginRequest, options?: AxiosRequestConfig) {
        return MainApiFp(this.configuration).apiMainSigninWithUsernamePasswordPost(platform, loginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



